import React from 'react';
import AniLink from 'gatsby-plugin-transition-link/AniLink';
import Image from 'gatsby-image';
import styles from '../../css/tour.module.css';
import { FaMap } from 'react-icons/fa';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';

const getImage = graphql`
  query {
    file(relativePath: { eq: "defaultBcg.jpeg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`;

const Tour = ({ name, price, country, days, slug, images }) => {
  const data = useStaticQuery(getImage);
  const img = data.file.childImageSharp.fluid;
  let mainImage = images[0].fluid ? images[0].fluid : img;
  return (
    <article className={styles.tour}>
      <div className={styles.imgContainer}>
        <Image
          fluid={mainImage}
          className={styles.img}
          alt="single tour"
        ></Image>
        <AniLink fade to={`tours/${slug}`} className={styles.link}>
          details
        </AniLink>
      </div>
      <div className={styles.footer}>
        <h3>{name}</h3>
        <div className={styles.info}>
          <h4 className={styles.country}>
            <FaMap className={styles.icon}></FaMap>
            {country || 'default country'}
          </h4>
          <div className={styles.details}>
            <h6>{days} days</h6>
            <h6>from ${price}</h6>
          </div>
        </div>
      </div>
    </article>
  );
};

Tour.propTypes = {
  name: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  country: PropTypes.string.isRequired,
  days: PropTypes.number.isRequired,
  images: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default Tour;
